<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

const DEFAULT_VALUE = 'top';

export default {
    name: 'tab-dock-location',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Tab Dock Location',
            tailwindDefinitionProp: 'tabDockLocation',
            value: DEFAULT_VALUE,
        };
    },

    computed: {
        options() {
            return this.themeObjectKeys.map((k) => {
                return {
                    text: this.titleCase(k).replace(' ', ':'),
                    value: k,
                };
            });
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            this.onAdd(valueNew);
            this.onOptionChange();
            this.value = valueNew;
        },

        onSelectedElement() {
            this.value = this.flexClassDefinition.key || DEFAULT_VALUE;
        },

        onAdd(valueNew) {
            switch (this.screen) {
                case 'mob':
                    this.addFlexClass({ key: valueNew, screen: 'mob' });
                    break;

                case 'tab':
                    this.addFlexClass({ key: valueNew, screen: 'tab' });
                    break;

                case 'lap':
                    this.addFlexClass({ key: valueNew, screen: 'lap' });
                    break;

                default:
                    this.addFlexClass({ key: valueNew, screen: 'mob' });
                    this.addFlexClass({ key: valueNew, screen: 'tab' });
                    this.addFlexClass({ key: valueNew, screen: 'lap' });
                    this.addFlexClass({ key: valueNew, screen: 'des' });
            }
        },
    },
};
</script>
